import { useTranslation } from 'react-i18next';

export default function Search() {
    const { t } = useTranslation();
    return (

        <form className="d-none d-lg-block mx-3 w-100" method="get" title="Search Form" action="https://cse.google.com/cse?cx=310c2ec76f4754cf0">
            <div>
                <input className="form-control-sm border-0 w-100" type="search" id="searchMasar" name="searchMasar" alt="Search in Site" maxLength="256" placeholder={t("Search")}
                    aria-label="Search" />
                <input type="hidden" id="cx" name="cx" value="013626029654558379071:ze3tw4csia4" />
            </div>
        </form>

    )
};


export function SearchInput({ searchQuery, setSearchQuery }) {
    const { t } = useTranslation();

    return (
        <input
            name="queryRequests"
            className="form-control-sm border-0 col-8 mt-2 me-2"
            type="search"
            placeholder={t("Search")}
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
        // onBlur={() => setSearching(false)}

        />

    )
}

export function LibrarySearch({ searchQuery, selectedCategory, libCategory, handleSearchChange }) {
    const { i18n } = useTranslation();


    // Add check for libCategory
    if (!Array.isArray(libCategory)) {
        return null; // or return a loading state
    }

    return (
        <input
            name="queryBooks"
            className="form-control-sm border my-2 col-8 col-md-4"
            type="search"
            placeholder={
                i18n.language === "ar"
                    ? selectedCategory
                        ? `البحث في تصنيف ${libCategory.find(category => category.id === selectedCategory)?.nameAr || ""
                        }`
                        : `البحث باسم المؤلف / الكتاب / سنة النشر`
                    :
                    selectedCategory
                        ? `Search in ${selectedCategory}` //fixed as recomended by Github Copilot the old one "`Search in ${selectedCategory || """
                        : `Search by author / book name / published year`
            }
            value={searchQuery}
            onChange={handleSearchChange} />

    )
}

